import { Outlet } from '@tanstack/react-router';
import React from 'react';
import StickyBox from 'react-sticky-box';

import ColumnLoading from '@/components/column-loading';
import Layout, { useWindowControlsOverlay } from '@/components/ui/layout';

const DashboardPage = React.lazy(() => import('@/pages/dashboard/dashboard'));

const AdminSections: React.FC = () => {
  const wcoRect = useWindowControlsOverlay();
  const offsetTop = wcoRect && wcoRect.x > 0 ? 16 + wcoRect.y : 16;

  return (
    <aside className='layout__admin-sections'>
      <StickyBox offsetTop={offsetTop} className={undefined} style={undefined}>
        <React.Suspense fallback={<ColumnLoading />}>
          <DashboardPage aside />
        </React.Suspense>
      </StickyBox>
    </aside>
  );
};

const AdminLayout: React.FC = () => (
  <>
    <AdminSections />

    <Layout.Main>
      <Outlet />
    </Layout.Main>
  </>
);

export { AdminLayout as default };
